export const DownloadOverlayInit = {
  visibility: false,
  offsetX: null,
  offsetY: null,
  url: null,
}
